// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-6508f8fa] .el-card.is-always-shadow{-webkit-box-shadow:none;box-shadow:none;padding:0 4px}.padding-24[data-v-6508f8fa]{padding:20px 24px 0}", ""]);
// Exports
module.exports = exports;
